import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { LOADING_STATUS } from 'shared/constants';

import { MapState } from '../../types';

import { getPlannedRoutesPrices } from '../operations/getPlannedRoutesPrices';

export const setRoutePrices = (builder: ActionReducerMapBuilder<MapState>) => builder
  .addCase(getPlannedRoutesPrices.pending, (state) => {
    state.routes.routePricesLoadingStatus = LOADING_STATUS.load;
  })
  .addCase(getPlannedRoutesPrices.fulfilled, (state, { payload }) => {
    state.routes.routePricesLoadingStatus = LOADING_STATUS.done;
    state.routes.routePrices = payload.routes;
    state.routes.stationServicePrices = payload.stationServicePrices;
  })
  .addCase(getPlannedRoutesPrices.rejected, (state) => {
    state.routes.routePricesLoadingStatus = LOADING_STATUS.error;
  });
